export const PERMISSIONS = {
    DASHBOARD: 'dashboard',
    DASHBOARD_OVERDUE_JOB: 'dashboard-overdue-job',
    DASHBOARD_DEFFER_JOB: 'dashboard-deffer-job',
    DASHBOARD_JOB_DONE: 'dashboard-job-done',
    DASHBOARD_REQUISITION: 'dashboard-requisition',
    DASHBOARD_AUTO_REQUISITION: 'dashboard-auto-requisition',
    DASHBOARD_PENDING_QUOTATION: 'dashboard-pending-quotation',
    DASHBOARD_SUPPLIER_QUOTATION: 'dashboard-supplier-quotation',
    DASHBOARD_PENDING_PURCHASE: 'dashboard-pending-purchase',
    DASHBOARD_BUDGET_HEAD_CHART: 'dashboard-budget-head-chart',

    MAINTENANCE: 'maintenance',
    MAINTENANCE_JOB_INSTRUCTION: 'maintenance-job-instruction',
    MAINTENANCE_JOB_DONE: 'maintenance-job-done',
    MAINTENANCE_JOB_DONE_ADD: 'maintenance-job-done-add',
    MAINTENANCE_JOB_DONE_UPDATE: 'maintenance-job-done-update',
    MAINTENANCE_JOB_DONE_APPROVAL: 'maintenance-job-done-approval',
    MAINTENANCE_JOB_DONE_OFFICE_APPROVAL: 'maintenance-job-done-office-approval',
    MAINTENANCE_DEFER_JOB: 'maintenance-defer-job',
    MAINTENANCE_DEFER_JOB_ADD: 'maintenance-defer-job-add',
    MAINTENANCE_DEFER_JOB_ADD_APPROVAL: 'maintenance-defer-job-add-approval',
    MAINTENANCE_DEFER_JOB_OFFICE_APPROVAL: 'maintenance-defer-job-office-approval',
    MAINTENANCE_RISK_ASSESSMENT: 'maintenance-risk-assessment',
    MAINTENANCE_SECOND_ENGINEER_RISK_ASSESSMENT: 'maintenance-second-engineer-risk-assessment',
    MAINTENANCE_SECOND_ENGINEER_PERMIT_TO_WORK: 'maintenance-second-engineer-permit-to-work',
    MAINTENANCE_PERMIT_TO_WORK: 'maintenance-permit-to-work',
    MAINTENANCE_PERMIT_TO_WORK_ADD: 'maintenance-permit-to-work-add',
    MAINTENANCE_PERMIT_TO_WORK_UPDATE: 'maintenance-permit-to-work-update',
    MAINTENANCE_ASSIGNED_RANKED: 'maintenance-assigned-ranked',
    MAINTENANCE_PRINT: 'maintenance-print',

    SUPPLIER_TYPE: 'supplier-type',
    SUPPLIER_TYPE_CREATE: 'supplier-type-create',
    SUPPLIER_TYPE_EDIT: 'supplier-type-edit',
    SUPPLIER_TYPE_DELETE: 'supplier-type-delete',

    SUPPLIER: 'supplier',
    SUPPLIER_CREATE: 'supplier-create',
    SUPPLIER_EDIT: 'supplier-edit',
    SUPPLIER_DELETE: 'supplier-delete',
    SUPPLIER_PRINT: 'supplier-print',

    JOB: 'job',
    JOB_ADD: 'job-add',
    JOB_EDIT: 'job-edit',
    JOB_INSTRUCTION: 'job-instruction',
    JOB_RUNNING_HOUR: 'job-running-hour',
    JOB_QR_CODE: 'job-qr-code',
    JOB_ARCHIVE_SCHEDULE: 'job-archive-schedule',
    JOB_COPY_COMPONENT: 'job-copy-component',
    JOB_DELETE: 'job-delete',
    JOB_ADD_ASSIGNED_RANK: 'job-add-assigned-rank',
    JOB_AUTO_APPROVAL: 'job-auto-approval',
    JOB_PENDING_APPROVE: 'approve-pending-job',
    JOB_ALL_SHOW: 'job-show-all',
    JOB_PRINT: 'job-print',

    ITEM: 'item',
    ITEM_ADD: 'item-add',
    ITEM_EDIT: 'item-edit',
    ITEM_DELETE: 'item-delete',
    ITEM_SHOW: 'item-show',
    ITEM_QR_CODE: 'item-qr-code',
    ITEM_STOCK_ADJUST: 'item-stock-adjust',
    ITEM_PRINT: 'item-print',
    ITEM_CRITICAL_EQUIPMENT: 'item-critical-equipment',
    ITEM_CRITICAL_EQUIPMENT_PRINT: 'item-critical-equipment-print',
    ITEM_OTHER_CONSUMPTION_HISTORY: 'item-other-consumption-history',
    ITEM_OTHER_CONSUMPTION_HISTORY_PRINT: 'item-other-consumption-history-print',

    REQUISITION: 'requisition',
    REQUISITION_ADD: 'requisition-add',
    REQUISITION_EDIT: 'requisition-edit',
    REQUISITION_SHOW: 'requisition-show',
    REQUISITION_DELETE: 'requisition-delete',
    REQUISITION_COPY: 'requisition-copy',
    REQUISITION_RFQ: 'requisition-rfq',
    REQUISITION_DATA_LIST: 'requisition-data-list',
    REQUISITION_PRINT: 'requisition-print',

    AUTO_REQUISITION: 'auto-requisition',
    AUTO_REQUISITION_PRINT: 'auto-requisition-print',

    QUOTATION: 'quotation',
    QUOTATION_LIST: 'quotation-list',
    QUOTATION_VIEW: 'quotation-view',
    CREATE_SUPPLIER_QUOTATION: 'create-supplier-quotation',

    SUPPLIER_QUOTATION: 'supplier-quotation',
    SUPPLIER_QUOTATION_LIST: 'supplier-quotation-list',
    SUPPLIER_QUOTATION_VIEW: 'supplier-quotation-view',
    SUPPLIER_QUOTATION_COMPARE: 'supplier-quotation-compare',
    SUPPLIER_QUOTATION_PO_CREATE: 'supplier-quotation-po-create',

    PURCHASE_ORDER: 'purchase-order',
    PURCHASE_RETURN_LIST: 'purchase-return-list',
    PURCHASE_ORDER_LIST: 'purchase-order-list',
    PURCHASE_ORDER_CREATE: 'purchase-order-create',
    PURCHASE_ORDER_EDIT: 'purchase-order-edit',
    PURCHASE_ORDER_VIEW: 'purchase-order-view',

    RECEIVE_ITEMS: 'receive-items',
    RECEIVE_ITEMS_PRINT: 'receive-items-print',
    RECEIVE_ITEMS_RECEIVE: 'receive-items-receive',


    SERVICE_RECEIVE_ITEMS: 'service-receive-items',
    LESS_DELIVERY_LIST: 'less-delivery-list',

    INVOICE: 'invoice',
    VENDOR_EVALUATION: 'vendor-evaluation',

    CHIEF_ENGINEER_APPROVAL: 'chief-engineer-approval',
    SUPERINTENDING_APPROVAL: 'superintending-approval',
    PM_APPROVAL: 'pm-approval',
    TM_APPROVAL: 'tm-approval',

    PURCHASE_RETURN: 'purchase-return',
    PURCHASE_RETURN_CREATE: 'purchase-return-create',
    PURCHASE_RETURN_DELETE: 'purchase-return-delete',
    PURCHASE_RETURN_VIEW: 'purchase-return-view',
    PURCHASE_RETURN_ADJUST: 'purchase-return-adjust',

    DEPARTMENT: 'department',
    DEPARTMENT_CREATE: 'department-create',
    DEPARTMENT_EDIT: 'department-edit',
    DEPARTMENT_DELETE: 'department-delete',
    DEPARTMENT_VIEW: 'department-view',
    DEPARTMENT_PRINT: 'department-print',

    MAIN_COMPONENT: 'main-component',
    MAIN_COMPONENT_CREATE: 'main-component-create',
    MAIN_COMPONENT_EDIT: 'main-component-edit',
    MAIN_COMPONENT_DELETE: 'main-component-delete',
    MAIN_COMPONENT_PRINT: 'main-component-print',

    COMPONENT: 'component',
    COMPONENT_VIEW: 'component-view',
    COMPONENT_CREATE: 'component-create',
    COMPONENT_EDIT: 'component-edit',
    COMPONENT_DELETE: 'component-delete',
    COMPONENT_PRINT: 'component-print',

    SUB_COMPONENT: 'sub-component',
    SUB_COMPONENT_CREATE: 'sub-component-create',
    SUB_COMPONENT_EDIT: 'sub-component-edit',
    SUB_COMPONENT_DELETE: 'sub-component-delete',
    SUB_COMPONENT_PRINT: 'sub-component-print',

    SUB_SUB_COMPONENT: 'sub-sub-component',
    SUB_SUB_COMPONENT_CREATE: 'sub-sub-component-create',
    SUB_SUB_COMPONENT_EDIT: 'sub-sub-component-edit',
    SUB_SUB_COMPONENT_DELETE: 'sub-sub-component-delete',
    SUB_SUB_COMPONENT_PRINT: 'sub-sub-component-print',

    JOB_TYPE: 'job-type',
    JOB_TYPE_VIEW: 'job-type-view',
    JOB_TYPE_CREATE: 'job-type-create',
    JOB_TYPE_EDIT: 'job-type-edit',
    JOB_TYPE_DELETE: 'job-type-delete',

    SCE: 'sce',
    SCE_VIEW: 'sce-view',
    SCE_LIST_CREATE: 'sce-create',
    SCE_LIST_EDIT: 'sce-edit',

    VESSEL: 'vessel',
    VESSEL_CREATE: 'vessel-create',
    VESSEL_EDIT: 'vessel-edit',
    VESSEL_DELETE: 'vessel-delete',
    VESSEL_PRINT: 'vessel-print',

    VESSEL_TYPE: 'vessel-type',
    VESSEL_TYPE_CREATE: 'vessel-type-create',
    VESSEL_TYPE_EDIT: 'vessel-type-edit',
    VESSEL_TYPE_DELETE: 'vessel-type-delete',

    VESSEL_CERTIFICATE: 'vessel-certificate',
    VESSEL_CERTIFICATE_CREATE: 'vessel-certificate-create',
    VESSEL_CERTIFICATE_EDIT: 'vessel-certificate-edit',
    VESSEL_CERTIFICATE_DELETE: 'vessel-certificate-delete',
    VESSEL_CERTIFICATE_PRINT: 'vessel-certificate-print',

    VESSEL_CERTIFICATE_TYPE: 'vessel-certificate-type',
    VESSEL_CERTIFICATE_TYPE_CREATE: 'vessel-certificate-type-create',
    VESSEL_CERTIFICATE_TYPE_EDIT: 'vessel-certificate-type-edit',
    VESSEL_CERTIFICATE_TYPE_DELETE: 'vessel-certificate-type-delete',
    VESSEL_CERTIFICATE_TYPE_PRINT: 'vessel-certificate-type-print',

    DATA_CLONE: 'data-clone',

    VESSEL_SELECT: 'vessel-select',
    DRYDOCK: 'drydock',

    REQUISITION_REPORT: 'requisition-reports',
    REQUISITION_REPORT_PRINT: 'requisition-reports-print',

    QUOTATION_REPORT: 'quotation-reports',
    PURCHASE_REPORT: 'purchase-reports',
    INVOICE_REPORT: 'invoice-reports',

    STOCK_LEDGER_REPORT: 'stock-ledger-reports',
    STOCK_LEDGER_REPORT_PRINT: 'stock-ledger-reports-print',

    LOCATION_WISE_STOCK_REPORT: 'location-wise-stock-report',
    LOCATION_WISE_STOCK_REPORT_PRINT: 'location-wise-stock-report-print',

    MAINTENANCE_HISTORY_REPORT: 'maintenance-history-report',
    MAINTENANCE_HISTORY_REPORT_PRINT: 'maintenance-history-report-print',

    BREAKDOWN_HISTORY_REPORT: 'breakdown-history-report',
    BREAKDOWN_HISTORY_REPORT_PRINT: 'breakdown-history-report-print',

    OVERDUE_JOB_REPORT: 'overdue-job-report',
    OVERDUE_JOB_REPORT_PRINT: 'overdue-job-report-print',

    SPARE_PARTS_CONSUMPTION_HISTORY_REPORT: 'spare-parts-consumption-history-report',
    SPARE_PARTS_CONSUMPTION_HISTORY_REPORT_PRINT: 'spare-parts-consumption-history-report-print',

    JOB_PLANNER_REPORT: 'job-planner-report',
    JOB_PLANNER_REPORT_PRINT: 'job-planner-report-print',

    INCIDENT_REPORT: 'incident-report',

    RETURN_DAMAGE_RECEIVE_ITEM_REPORT: 'return-damage-and-not-received-item-reports',
    RETURN_DAMAGE_RECEIVE_ITEM_REPORT_PRINT: 'return-damage-and-not-received-item-reports-print',

    SERVICE_REQ_RETURN_ITEM_REPORT: 'service-req-return-item-report',

    RUNNING_HOUR_JOBS_REPORT: 'running-hour-jobs-report',
    RUNNING_HOUR_JOBS_REPORT_PRINT: 'running-hour-jobs-report-print',

    DEFERRED_JOB_REPORT: 'deferred-job-report',
    DEFERRED_JOB_REPORT_PRINT: 'deferred-job-report-print',

    COMPONENT_MATRIX_REPORT: 'component-matrix-report',
    COMPONENT_MATRIX_REPORT_PRINT: 'component-matrix-report-print',

    CRITICAL_JOBS_REPORT: 'critical-jobs-report',
    CRITICAL_JOBS_REPORT_PRINT: 'critical-jobs-report-print',

    CRITICAL_COMPONENTS_REPORT: 'critical-components-report',
    CRITICAL_COMPONENTS_REPORT_PRINT: 'critical-components-report-print',

    CRITICAL_MAINTENANCE_HISTORY_REPORT: 'critical-maintenance-history-report',
    CRITICAL_MAINTENANCE_HISTORY_REPORT_PRINT: 'critical-maintenance-history-report-print',

    CRITICAL_SPARES_ITEM_REPORT: 'critical-spare-item-report',
    CRITICAL_SPARES_ITEM_REPORT_PRINT: 'critical-spare-item-report-print',

    USERS: 'users',
    USERS_CREATE: 'users-create',
    USERS_EDIT: 'users-edit',
    USERS_DELETE: 'users-delete',
    USERS_PRINT: 'users-print',

    LOCATION: 'location',
    LOCATION_CREATE: 'location-create',
    LOCATION_EDIT: 'location-edit',
    LOCATION_DELETE: 'location-delete',

    CATEGORY: 'category',
    CATEGORY_CREATE: 'category-create',
    CATEGORY_EDIT: 'category-edit',
    CATEGORY_DELETE: 'category-delete',

    CURRENCY: 'currency',
    CURRENCY_CREATE: 'currency-create',
    CURRENCY_EDIT: 'currency-edit',
    CURRENCY_DELETE: 'currency-delete',

    UNIT: 'unit',
    UNIT_CREATE: 'unit-create',
    UNIT_EDIT: 'unit-edit',
    UNIT_DELETE: 'unit-delete',

    COUNTRY: 'country',
    COUNTRY_CREATE: 'country-create',
    COUNTRY_EDIT: 'country-edit',
    COUNTRY_DELETE: 'country-delete',

    PORT: 'port',
    PORT_CREATE: 'port-create',
    PORT_EDIT: 'port-edit',
    PORT_DELETE: 'port-delete',

    EXPORT_IMPORT: 'export-import',

    TICKET_CATEGORY: 'ticket-category',
    TICKET_CATEGORY_CREATE: 'ticket-category-create',
    TICKET_CATEGORY_EDIT: 'ticket-category-edit',
    TICKET_CATEGORY_DELETE: 'ticket-category-delete',

    SUPPORT_TICKET: 'ticket',
    SUPPORT_TICKET_CREATE: 'ticket-create',
    SUPPORT_TICKET_EDIT: 'ticket-edit',
    SUPPORT_TICKET_DELETE: 'ticket-delete',

    BUDGET_HEAD: 'budget-head',
    BUDGET: 'budget',
    BUDGET_REPORT: 'budget-report',
    ROLE_PERMISSION: 'role-permission',

    NON_CONFORMITY: 'non-conformity',
    NC_CORRECTIVE_ACTION: 'nc-corrective-action',

    COMPONENT_TREE: 'component-tree',
    CMMS_OVERALL_KPI: 'cmms-overall-kpi',
    CMMS_WORK_ORDER_SUMMARY: 'cmms-work-order-summary',
    CMMS_TOTAL_WORK_ORDER_OVERVIEW: 'cmms-total-work-order-overview',
    CMMS_SCE_EXECUTION_SUMMARY: 'cmms-sce-execution-summary',
    CMMS_TOTAL_WORK_ORDER_BACKLOG: 'cmms-total-work-order-backlog',
};

